export const PROPOSAL_QUOTATION_PAYMENT_METHODS =
  'proposal/quotation/payment_methods'
